import React from 'react';
import { useDispatch } from 'react-redux';
import StandardModal from 'modals/StandardModal';
import { closeModal } from 'data/reducers/modalReducer';
import {
	ALL_HEALTH_VALUES,
	HEALTH_DESCRIPTION,
	HEALTH_LABEL,
	HEALTH_THRESHOLD,
	HEALTH_TONE,
} from './HealthChip';

/**
 * Defines all seven health verdicts, in the order the backend evaluates them.
 *
 * A modal rather than a tooltip because the summary tiles hide any verdict
 * whose count is zero: the statuses a reader has never seen are exactly the
 * ones with no explanation anywhere on screen, and only a list independent of
 * today's numbers can cover them.
 */
const DatasetHealthLegend = () => {
	const dispatch = useDispatch();

	return (
		<StandardModal
			title="What the statuses mean"
			size="lg"
			className="dataset-health-legend-modal"
			closeOnOutsideClick
			closeLabel="Close"
			onClose={() => dispatch(closeModal())}
		>
			<p className="text-muted small mb-3">
				Evaluated in this order, and the first match wins, so a dataset shows
				only one status. A red status hides anything below it: a dataset that
				is not running may also have degraded coverage, and that will not
				appear until the run is fixed.
			</p>

			<ol className="dataset-health-legend">
				{ALL_HEALTH_VALUES.map((health) => (
					<li key={health} className="dataset-health-legend-item">
						<span className={`health-chip chip-${HEALTH_TONE[health]}`}>
							<span className="health-chip-dot" aria-hidden="true" />
							{HEALTH_LABEL[health]}
						</span>
						<p className="mb-1 mt-2">{HEALTH_DESCRIPTION[health]}</p>
						<p className="text-muted small mb-0">{HEALTH_THRESHOLD[health]}</p>
					</li>
				))}
			</ol>

			<p className="text-muted small mb-0">
				Grey is not a warning. Warming up and No watched properties both mean
				there is nothing to judge, and colouring them red would drown the two
				states that need attention.
			</p>
		</StandardModal>
	);
};

export default DatasetHealthLegend;
